import { gql } from '@apollo/client';

/**
 * Payouts-internal Ops mutation to publish a company's treasury (North -> KodoPay) auto-approve
 * workflow (KODO_PAY / TREASURY_PAYMENT). The company's own payment workflows are not touched. Wraps
 * the SUPER_ADMIN / BACKEND_SCRIPT_RUNNER guarded resolver in kodo-backend `approval-workflow.resolver.ts`.
 * Seeds the company passed in `companyId`; the ops user stays signed into their own company.
 *
 * Field name is verified against
 * `kodo-backend/src/modules/approval-workflow/graphql/approval-workflow.graphql`.
 */

// mutation pvtSeedTreasuryAutoApproveWorkflowForCompany(
//   input: SeedTreasuryAutoApproveWorkflowInput!  # { companyId: ID! }
// ): Boolean!
export const pvtSeedTreasuryAutoApproveWorkflowForCompanyGQL = gql`
mutation pvtSeedTreasuryAutoApproveWorkflowForCompany(
  $input: SeedTreasuryAutoApproveWorkflowInput!
) {
  pvtSeedTreasuryAutoApproveWorkflowForCompany(input: $input)
}
`;

export const TreasuryAutoApproveWorkflowGQL = {
  pvtSeedTreasuryAutoApproveWorkflowForCompany: pvtSeedTreasuryAutoApproveWorkflowForCompanyGQL,
};
